<template>
    <router-link tag="li" class="nav-item dropdown" :to="url" >
        <!-- :class="{'open': toogle_dropdown}" v-on:click.native="handleClick"> -->
        <a class="dropdown-toggle">
            <span class="icon-holder">
                <i :class="classIcon"></i>
            </span>
            <span class="title" font-size="14px">{{name}}</span>
            <span class="arrow">
                <i class="ti-angle-right"></i>
            </span>
        </a>
        <ul class="dropdown-menu">
            <slot></slot>
        </ul>
    </router-link>
</template>

<script>
    export default {
        name: "side-nav-dropdown",
        data() {
            return {
                toogle_dropdown: false
            }
        },
        props: {
            name: {
                type: String,
                default: ''
            },
            url: {
                type: String,
                default: ''
            },
            icon: {
                type: String,
                default: ''
            }
        },
        computed: {
            classIcon () {
                return [
                    this.icon
                ]
            }
        },
        methods: {
            handleClick: function () {
                this.toogle_dropdown = !this.toogle_dropdown;
            }
        }
    }
</script>